import { render } from "./CreatePackageForm.vue?vue&type=template&id=0f8d621b&scoped=true"
import script from "./CreatePackageForm.vue?vue&type=script&lang=js"
export * from "./CreatePackageForm.vue?vue&type=script&lang=js"

import "./CreatePackageForm.vue?vue&type=style&index=0&id=0f8d621b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8d621b"]])

export default __exports__